module.exports = __webpack_public_path__ + "static/media/logo-왓섭@3x.fa29a189.png";